import { TravellersSelection } from '@secretescapes/cauldron';

export interface SelectionState {
  offerId: string;
  travellersSelection: TravellersSelection;
  // rooms: number;
}

export enum SelectionActionType {
  OfferIdChange = 'OfferIdChange',
  TravellersSelectionChange = 'TravellersSelectionChange',
  // RoomsChange = 'RoomsChange',
}

export interface OfferIdChangeAction {
  type: SelectionActionType.OfferIdChange;
  payload: string;
}

export interface TravellersSelectionChangeAction {
  type: SelectionActionType.TravellersSelectionChange;
  payload: TravellersSelection;
}

// export interface RoomsChangeAction {
//   type: SelectionActionType.RoomsChange;
//   payload: number;
// }

export type SelectionAction = OfferIdChangeAction | TravellersSelectionChangeAction;
// | RoomsChangeAction
